import { type SelectInputProps, SelectInput } from "react-admin";

const PRIVACY_TYPE_CHOICES = [
  {
    name: "freedom",
    id: "freedom",
  },
  {
    name: "usual",
    id: "usual",
  },
];

export const RadiusVpnServerPrivacyTypeInput = (
  props: Omit<SelectInputProps, "choices">,
) => <SelectInput {...props} choices={PRIVACY_TYPE_CHOICES} />;
